module.exports = __webpack_public_path__ + "static/media/IMG-12.c9cf0499.jpg";